import { render } from "./AddUser.vue?vue&type=template&id=13e47c77&scoped=true"
import script from "./AddUser.vue?vue&type=script&lang=js"
export * from "./AddUser.vue?vue&type=script&lang=js"

import "./AddUser.vue?vue&type=style&index=0&id=13e47c77&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-13e47c77"

export default script